import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorCommunityFormat from "@travily/types/pages/FoundingMemberCreatorCommunityFormat";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { CommunityFormatStepView } from "./show.view";

type FormData = {
  community_profile: {
    hubs_formats: string[];
  };
};

const FIELD = "community_profile.hubs_formats";

const FormatStep = ({
  stage_index,
  stage_order,
  community_profile,
  hub_count,
}: FoundingMemberCreatorCommunityFormat) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("community", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "format",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { community_profile: { hubs_formats: community_profile.hubs_formats ?? [] } },
    });

  const selectedValues = form.data.community_profile.hubs_formats;
  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  const onSelectionChange = (values: string[]) => {
    form.setData(FIELD, values);
    validate(FIELD);
  };

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.community.format.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.community.format.show.meta_description")}
        />
      </Head>
      <CommunityFormatStepView
        currentStage={currentStage}
        totalStages={totalStages}
        hubCount={hub_count}
        selectedValues={selectedValues}
        primaryPending={primaryPending}
        error={error}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
};

export default FormatStep;
